var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",class:{ 'full-screen': _vm.fullScreen }},[_c('div',{staticClass:"loading-circle"}),_c('div',{staticClass:"loading-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }